import { Component, Injectable } from '@angular/core';
import {NgbDatepickerI18n, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {TranslationWidth} from "@angular/common";

const DATEPICKER_VALUES = {
  'pt-br': {
    weekdays: ['seg', 'ter', 'qua', 'qui', 'sex', 'sab','dom'],
    months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  },
};

@Injectable()
export class I18n {
  language = 'pt-br';
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  constructor(private i18n: I18n) {
    super();
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return date.day.toString();
  }

  getMonthFullName(month: number, year?: number): string {
    return this.getMonthShortName(month);
  }

  getMonthShortName(month: number, year?: number): string {
    // @ts-ignore
    return DATEPICKER_VALUES[this.i18n.language].months[month - 1];
  }

  getWeekdayLabel(weekday: number, width?: TranslationWidth): string {
    // @ts-ignore
    return DATEPICKER_VALUES[this.i18n.language].weekdays[weekday - 1];
  }
}
